import { type AttributesObject } from '@hooks-api/types/dataModel/products'

export const parseAttributesToArray = (attributes: AttributesObject) => Object.values(attributes)
export const parseAttributesToString = (attributes: AttributesObject = {}) => parseAttributesToArray(attributes).join(' | ')

/** 優先使用 display_name，fallback 回 attributes 轉字串 */
export const getDisplayAttributes = (product?: { display_name?: string, attributes?: AttributesObject }) =>
  product?.display_name || parseAttributesToString(product?.attributes)
